import { Injectable } from '@angular/core';
import { IID_CHECKLIST_GISFO } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDChecklistGISFOStore } from './iidChecklistGISFO.store';
import { IIDChecklistGISFOQuery } from './iidChecklistGISFO.query';
import { WsACKCallback } from '@common/api/ack';
import { RealtimeFeatureCommandService } from '@ep-om/realtime-v2';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.CHECKLIST_GISFO)
export class IIDChecklistGISFOService extends CrudService<IID_CHECKLIST_GISFO, IIDChecklistGISFOStore, IIDChecklistGISFOQuery> {
  constructor(
    protected store: IIDChecklistGISFOStore,
    public query: IIDChecklistGISFOQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
    private featureCommandService: RealtimeFeatureCommandService,
  ) {
    super(Topics.IID_CHECKLIST_GISFO, store, query, actionService, updateStrategy);
  }

  refreshFromGISFO(id: string, fkEntity: string, callback?: WsACKCallback<void>) {
    const dto = { id, fkEntity };
    this.featureCommandService.send<void>(
      {
        target: 'feature:checklist-gisfo',
        command: 'refresh',
        dto,
        ...this.projectIdFromEntity(id),
      },
      () => this.actionService.sendMessage(Topics.IID_CHECKLIST_GISFO, 'refresh', dto, callback),
      callback,
    );
  }

  private projectIdFromEntity(id: string): { projectId?: string } {
    const projectId = this.query.getEntity(id)?.projectId;
    return projectId ? { projectId } : {};
  }
}
